import $ from "jquery";
import Homepage from "./pages/homepage";
import Page from "./pages/page";
import Mobile from "./pages/mobile";
import Websites from "./pages/websites";
import Switch from "./pages/switch";
import Sign from "./pages/sign";
import Navigation from "./components/navigation";
import Modal from "./components/modal";
var objectFitImages = require("object-fit-images");

class App {
  constructor() {
    this.init();
  }

  init() {
    this.body = $("body");
    this.addEvents();

    this.navigation = new Navigation();
    this.getPageScripts();
    this.modal = new Modal();

    this.navigation.init();
    objectFitImages();
  }

  getPageScripts() {
    if (this.body.hasClass("page-home")) {
      this.pageBase = new Homepage();
    } else if (this.body.hasClass("page-mobile")) {
      this.pageBase = new Mobile();
    } else if (this.body.hasClass("page-websites")) {
      this.pageBase = new Websites();
    } else if (this.body.hasClass("page-switch")) {
      this.pageBase = new Switch();
    } else if (this.body.hasClass("page-sign")) {
      this.pageBase = new Sign();
    } else {
      this.pageBase = new Page();
    }
  }

  complete() {
    $("html").addClass("initialized");
  }

  addEvents() {}
}

module.exports = App;
